import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, Col, Row, CardBody } from "reactstrap"
import { get, post } from 'helpers/api_helper'
import Datatables from "components/Datatables/datatable";
import moment from "moment";
import Toaster from "components/toster";

const MapConfig = () => {
    const [formData, setFormData] = useState({
        try_no: null,
        case_no: null
    });
    const [dataRows, setDataRows] = useState([]);
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })

    const submitForm = async() => {
        const { status, msg } = await post('/api/tryprocess/maptry', formData);
        if(status){
            setFormData({
                case_no: null
            })
            fetchData()
        }else{
            Toaster('error', {message: msg, title: 'Try Mapping Error'})
        }
    }

    const fetchData = async() => {
        const { status, data } = await get('/api/tryprocess/getalltrys');
        if(status){
            setDataRows(data);
        }
    }
    useEffect(fetchData, []);

    const datatableColumns = [
        { dataField: 'id', text: '#', formatter: (cell, row, rowIndex) => {
            const page = pagination?.page || 1;
            const limit = pagination?.limit || 10;
            return (page - 1) * limit + (rowIndex + 1);
        }}, {
            dataField: 'case_no',
            text: 'Case / Order No'
        }, {
            dataField: 'datetime',
            text: 'Added Date',
            formatter: (cell, row) => moment(cell).format('DD-MM-YYYY')
        }, {
            dataField: 'action',
            text: 'Added Time',
            formatter: (cell, row) => moment(cell).format('HH:mm:ss')
        }
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | Map Case in Process </title></MetaTags>
                <Container fluid>
                    <h3>Mapped Trys</h3>
                </Container>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Row>
                                    {/* <Col>
                                        <label>Tray No</label>
                                        <input className="form-control" value={formData?.try_no || ''} onChange={(e) => {
                                            setFormData(p => ({...p, try_no: e.target.value}))
                                        }} />
                                    </Col> */}
                                    <Col md={2}>
                                        <label>Case No</label>
                                        <input className="form-control" value={formData?.case_no || ''} onChange={(e) => {
                                            setFormData(p => ({...p, case_no: e.target.value}))
                                        }} />
                                    </Col>
                                    <Col md={2}>
                                        <button className="mt-4 form-control btn btn-primary" type="button" onClick={submitForm}> Assign to Tray</button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col xl="12">
                        <Card>
                            <CardBody>
                                <Datatables 
                                    isSearch={true}
                                    columns = {datatableColumns}
                                    showTableOnly={true}
                                    rowsLength = {dataRows?.total_rows || 0}
                                    rows = {dataRows?.rows || []}
                                    keyField={'id'}
                                    title = "All Mapped Try's"
                                    loading = {false}
                                    isAdd = {false}
                                    isTableHead = {true}
                                    ssr={setPagination}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default MapConfig
